import React from 'react';
import {
	View,
	Text,
} from 'react-native';

import { AuthCheckContainer } from '../../../common/containers/auth';

import { Spinner } from '../spinner/Spinner';
import { OfflineNotice } from '../network';
import AuthExpired from './AuthExpired';
import { ServiceRunListView } from '../../scenes/servicerun';
import TicketListView from '../../scenes/ticket/TicketListView';
import { MyDayView } from '../../scenes/myDay';
import { useUserContext } from '../../../common/utils';
import { HOME_PAGES, ROLE_PERMISSIONS } from '../../../common/constants';
import { isMyDayEnabledForUser } from '../../../common/utils/myDay/access';
import HomeView from '../../scenes/driver/HomeView';
import { isLegacyMobileUi } from '../../utils/legacyMobileUi';

const APP_RUNTIME = {
	IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
};

const AuthRedirect = () => {
	// Navigation is handled by AppNavigation based on auth state
	// Just show a message while the state updates
	return (
		<View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
			<Text>Please log in to continue</Text>
		</View>
	);
};

const homePageRouteSettings = {
	3: { component: ServiceRunListView },
	5: { component: TicketListView },
	9: { component: MyDayView },
};

// Everyone lands on the redesigned Home; the hidden legacyMobileUi fallback
// keeps the classic role-based home pages exactly as before.
export const HomeRoute = props => {
	const {
		user,
		hasPermission,
		tenantSettings,
		isAVC,
	} = useUserContext();

	if (!isLegacyMobileUi(user)) {
		return <HomeView {...props} />;
	}

	const homePageId = getHomePageId(user, hasPermission, { tenantSettings, isAVC });
	const HomePageComponent = (homePageRouteSettings[homePageId] || homePageRouteSettings[HOME_PAGES.SERVICE_RUN_LIST]).component;

	return <HomePageComponent key={homePageId} {...props} />;
};

const getHomePageId = (user, hasPermission, { tenantSettings, isAVC } = {}) => {
	if (isMyDayEnabledForUser({
		user,
		tenantSettings,
		isAVC,
		isDevelopment: APP_RUNTIME.IS_DEVELOPMENT,
	})) {
		return HOME_PAGES.MY_DAY;
	}

	// if role has home page defined
	if (user?.role?.mobileHomePage) {
		return user?.role?.mobileHomePage;
	}

	// if hasPermission not defined
	if (!hasPermission) {
		return HOME_PAGES.SERVICE_RUN_LIST;
	}

	if (hasPermission(ROLE_PERMISSIONS.VIEW_SERVICE_RUN_LIST_PAGE)) {
		return HOME_PAGES.SERVICE_RUN_LIST;
	}
	if (hasPermission(ROLE_PERMISSIONS.VIEW_TICKET_LIST_PAGE)) {
		return HOME_PAGES.TICKET_LIST;
	}

	return HOME_PAGES.SERVICE_RUN_LIST;
};

export default AuthCheckContainer({
	NotAuthenticatedRedirectComponent: AuthRedirect,
	AuthenticationExpiredComponent: AuthExpired,
	HeaderComponent: OfflineNotice,
	LoadingComponent: Spinner,
	HomePageComponent: HomeRoute,
});
